module.exports = __webpack_public_path__ + "img/Android@2x.021bdcc6.png";